import { defineComponent as _defineComponent } from 'vue'
import { ref } from '@nuxtjs/composition-api';
import { useConfirmationDialog } from '~/src/shared/composables/confirmationDialog';
import { i18n } from '~/src/shared/locales/i18n';

interface Props {
  classRoom: string;
  userName?: string;
  isOpened: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserLogin',
  props: {
    classRoom: null,
    userName: null,
    isOpened: { type: Boolean }
  },
  emits: ['signOut', 'toggleDialog', 'openMenu'],
  setup(__props: any, { emit }) {




// 確認ダイアログ
const {
  isOpenedConfirmationDialog,
  openConfirmationDialog,
  closeConfirmationDialog,
  confirmationMessage
} = useConfirmationDialog();

const confirmSigningOut = () => {
  confirmationMessage.value = i18n.confirm.signOut.$t();
  openConfirmationDialog();
};

const signOut = () => {
  closeConfirmationDialog();
  emit('signOut');
};

/** 教室切り替えダイアログ */
const isOpenedClassroomChangeDialog = ref(false);
const openClassroomChangeDialog = () => {
  isOpenedClassroomChangeDialog.value = true;
  emit('toggleDialog');
};
const closeClassroomChangeDialog = () => (isOpenedClassroomChangeDialog.value = false);

return { __sfc: true,emit, isOpenedConfirmationDialog, openConfirmationDialog, closeConfirmationDialog, confirmationMessage, confirmSigningOut, signOut, isOpenedClassroomChangeDialog, openClassroomChangeDialog, closeClassroomChangeDialog }
}

})